import React from 'react';
import { BackButton, MainCard, LicenseSelector } from '@components';
import { useParams } from 'react-router-dom';
import { get } from 'lodash';
import { useApiUserScope } from '@hooks';

export const DisplayName = 'Scope and Permissions';

export const App = () => {
    const routeParams = useParams();
    const id = get(routeParams, 'id');
    const name = get(routeParams, 'name');
    const { scopes, loading, updateScope } = useApiUserScope(id);

    const handleScopeChange = (scope: string, addOrRemove: "add" | "remove") => {
        updateScope(scope, addOrRemove);
    };

    return <MainCard title={`${DisplayName}-${name}`} secondary={<BackButton />}>
        <LicenseSelector initialScope={scopes} onScopeChange={handleScopeChange} disabled={loading} />
    </MainCard>;
};

export const params = ['id', 'name'];
export const name = 'appRegistrationViewScope';
export const open = (id: string, name: string, queryParams?: {}) => {
    return `/sub-apps/appRegistrationViewScope/id/${id}/name/${name}`;
};
